<template>
  <router-view>
    <notifications></notifications>
  </router-view>
</template>

<script>
import socketIOClient from 'socket.io-client'
import sailsIOClient from 'sails.io.js'

export default {
  name: 'app',
  async created() {
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.refreshing) return
        this.refreshing = true
        window.location.reload()
      })
    }
  },
  computed: {
    userInfo: {
      get() {
        return this.$store.state.userInfo
      }
    }
  },
  methods: {
    showRefreshUI(e) {
      this.registration = e.detail
      this.notify()
    },
    refreshApp() {
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage('skipWaiting')
    },
    notify() {
      this.$notify({
        type: 'primary',
        verticalAlign: 'bottom',
        horizontalAlign: 'center',
        message: 'New version available! Click here to update!',
        clickHandler: this.refreshApp()
      })
    }
  },
  data() {
    return {
      refreshing: false,
      registration: null
    }
  }
}
</script>
